export const formatMedicationCategoryName = (name) =>
  String(name || "").trim().toUpperCase() === "ALL" ? "OTHER" : name;
